import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["dialog"]

  connect() {
    // Bind the method to preserve 'this' context
    this.handleEscapeKey = this.handleEscapeKey.bind(this);
  }

  open(event) {
    event.preventDefault();
    this.dialogTarget.showModal();
    document.addEventListener('keydown', this.handleEscapeKey);
  }

  close(event) {
    if (event) {
      event.preventDefault();
    }
    this.dialogTarget.close();
    document.removeEventListener('keydown', this.handleEscapeKey);
  }

  backdropClose(event) {
    // Only close if clicking directly on the dialog backdrop, not on child elements
    if (event.target === this.dialogTarget) {
      this.close();
    }
  }

  handleEscapeKey(event) {
    if (event.key === 'Escape') {
      this.close();
    }
  }

  disconnect() {
    document.removeEventListener('keydown', this.handleEscapeKey);
  }
}
